import { AxiosError } from 'axios'

const SENSITIVE_KEYS = ['password', 'token']

function isSensitiveKey(key: string): boolean {
  const lower = key.toLowerCase()
  return SENSITIVE_KEYS.some((sensitive) => lower.includes(sensitive))
}

function removeSensitiveData<T>(data: T): T {
  if (data === null || typeof data !== 'object') {
    return data
  }

  if (Array.isArray(data)) {
    return data.map(removeSensitiveData) as T
  }

  const result: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
    if (isSensitiveKey(key)) {
      result[key] = '[REDACTED]'
    } else {
      result[key] = removeSensitiveData(value)
    }
  }
  return result as T
}

export function buildAxiosErrorContext(axiosError: AxiosError) {
  const responseData = axiosError.response?.data ?? {}

  let requestData: unknown = {}
  try {
    requestData =
      typeof axiosError.config?.data === 'string'
        ? JSON.parse(axiosError.config.data)
        : axiosError.config?.data ?? {}
  } catch {
    requestData = {}
  }

  return {
    requestData: removeSensitiveData(requestData),
    responseData: removeSensitiveData(responseData)
  }
}
